import { accountBadgeBackImageAttachmentKey, accountBadgeEntityName, accountBadgeFrontImageAttachmentKey, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import FlipOutlinedIcon from '@mui/icons-material/FlipOutlined';
import { Button } from '@mui/material';
import React from 'react';
export const AccountBadgePreview = (props) => {
    const { t } = useBadgingTranslation();
    const [isBackTemplateVisible, setIsBackTemplateVisible] = React.useState(false);
    const handleFlipTemplate = () => {
        setIsBackTemplateVisible((prevState) => !prevState);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Image, { entity: accountBadgeEntityName, entityId: props.accountBadge.id, attachmentKey: isBackTemplateVisible ? accountBadgeBackImageAttachmentKey : accountBadgeFrontImageAttachmentKey, sx: {
                width: '100%',
                borderRadius: 1,
                borderWidth: 1,
                borderColor: themeColors.border.main,
                borderStyle: 'solid',
            } }),
        React.createElement(Button, { startIcon: React.createElement(FlipOutlinedIcon, null), onClick: handleFlipTemplate }, t('badgePreview.flipBadge'))));
};
